module.exports = __webpack_public_path__ + "static/img/bg-Client-02.9daa21fb.png";